const { useI18n } = require('@fegobull/webapi').use;
const $t = useI18n({
    0: {
        succ_wait_use: {
            title: '领取成功',
            desc: '您可在5/1/2024-7/31/2024期间免费享用LV2行情报价。',
            btn: '查看奖励'
        },
        succ_can_use: {
            title: '领取成功',
            desc: '您可在即日起到7/31/2024期间免费享用LV2行情报价。',
            btn: '立即使用'
        },
        act_not_start: {
            title: '活动未开始',
            desc: '抱歉，活动未开始！',
            btn: '参与其他活动'
        },
        act_end: {
            title: '活动已结束',
            desc: '抱歉，活动已结束！请期待下次活动，感谢您的支持！',
            btn: '参与其他活动'
        },
        has_get: {
            title: '已领取',
            desc: '您可在5/1/2024-7/31/2024期间免费享用LV2行情报价。',
            btn: '查看奖励'
        },
        error_ip: {
            title: '领取失败',
            desc: '抱歉，您不符合本次活动客群。感谢您的支持。',
            btn: '参与其他活动'
        },
        error_account: {
            title: '领取失败',
            desc: '抱歉，此活动仅面向已有moomoo券商账户的用户参与。',
            btn: '立即开户'
        },
        get_now_btn: '立即领取',
        has_get_btn: '已领取',
        fetch_fail: '网络繁忙，请稍后再试',
        fetch_succ: '领取成功'
    },
    1: {
        succ_wait_use: {
            title: '領取成功',
            desc: '您可在5/1/2024-7/31/2024期間免費享用LV2行情報價。',
            btn: '查看獎勵'
        },
        succ_can_use: {
            title: '領取成功',
            desc: '您可在即日起到7/31/2024期間免費享用LV2行情報價。',
            btn: '立即使用'
        },
        act_not_start: {
            title: '活動未开始',
            desc: '抱歉，活動未开始！',
            btn: '參與其他活動'
        },
        act_end: {
            title: '活動已結束',
            desc: '抱歉，活動已結束！請期待下次活動，感謝您的支持！',
            btn: '參與其他活動'
        },
        has_get: {
            title: '已領取',
            desc: '您可在5/1/2024-7/31/2024期間免費享用LV2行情報價。',
            btn: '查看獎勵'
        },
        error_ip: {
            title: '領取失敗',
            desc: '抱歉，您不符合本次活動客群。感謝您的支持。',
            btn: '參與其他活動'
        },
        error_account: {
            title: '領取失敗',
            desc: '抱歉，此活動僅面向已有moomoo券商帳戶的用戶參與。',
            btn: '立即開戶'
        },
        get_now_btn: '立即領取',
        has_get_btn: '已領取',
        fetch_fail: '網路繁忙，請稍後再試',
        fetch_succ: '領取成功'
    },
    2: {
        succ_wait_use: {
            title: `Congrats! You're enrolled`,
            desc: 'You can begin using Nasdaq TotalView data from the 1st May until 31st July 2024',
            btn: 'Check now'
        },
        succ_can_use: {
            title: 'TotalView Now Unlocked',
            desc: 'You can now begin using Nasdaq TotalView data until the 31st July 2024',
            btn: 'Use now'
        },
        act_end: {
            title: 'Event ended',
            desc: `Sorry, this event has ended and we'll keep you updated on future promotions`,
            btn: 'Other promotions'
        },
        act_not_start: {
            title: 'Event not start',
            desc: `Sorry, this event has not started yet`,
            btn: 'Other promotions'
        },
        has_get: {
            title: 'Already enrolled',
            desc: 'Effective  period: 5/1/2024-7/31/2024',
            btn: 'Check now'
        },
        error_ip: {
            title: 'Failed To Enroll',
            desc: 'Unfortunately you do not meet the criteria to claim this promotion',
            btn: 'Other promotions'
        },
        error_account: {
            title: 'Failed To Enroll',
            desc: 'Sorry, this event is only available for users with active moomoo brokerage account',
            btn: 'Open account'
        },
        get_now_btn: 'Claim Now',
        has_get_btn: 'Already enrolled',
        fetch_fail: 'Network Error, Please try again later',
        fetch_succ: "Congrats! You're enrolled"
    },
    5: {
        succ_wait_use: {
            title: `Congrats! You're enrolled`,
            desc: 'You can begin using Nasdaq TotalView data from the 1st May until 31st July 2024',
            btn: 'Check now'
        },
        succ_can_use: {
            title: 'TotalView Now Unlocked',
            desc: 'You can now begin using Nasdaq TotalView data until the 31st July 2024',
            btn: 'Use now'
        },
        act_not_start: {
            title: 'Event not start',
            desc: `Sorry, this event has not started yet`,
            btn: 'Other promotions'
        },
        act_end: {
            title: 'Event ended',
            desc: `Sorry, this event has ended and we'll keep you updated on future promotions`,
            btn: 'Other promotions'
        },
        has_get: {
            title: 'Already enrolled',
            desc: 'Effective  period: 5/1/2024-7/31/2024',
            btn: 'Check now'
        },
        error_ip: {
            title: 'Failed To Enroll',
            desc: 'Unfortunately you do not meet the criteria to claim this promotion',
            btn: 'Other promotions'
        },
        error_account: {
            title: 'Failed To Enroll',
            desc: 'Sorry, this event is only available for users with active moomoo brokerage account',
            btn: 'Open account'
        },
        get_now_btn: 'Claim Now',
        has_get_btn: 'Already enrolled',
        fetch_fail: 'Network Error, Please try again later',
        fetch_succ: "Congrats! You're enrolled"
    }
});

export default $t;
